const QUERY_KEYS = {
  me: ['me'],

  project: {
    list: (params = {}) => ['userProjects', params],
    details: (id) => ['project', 'details', id],
    headerProjects: () => ['headerProjects'],
    assignedProjects: () => ['assignedProjects'],
    current: (id) => ['currentProject', id],
  },

  users: {
    list: (params = {}) => ['users', params],
    details: (userId) => ['user', userId],
    headerUsers: (params = {}) => ['headerUsers', params],
    projectAccess: () => ['userProjectAccess'],
  },

  testCase: {
    list: (projectId) => ['testcases', projectId],
    details: (testCaseId) => ['testcase', testCaseId],
    linkedIssues: (testCaseId) => ['linkedIssues', testCaseId],
  },

  testCycle: {
    list: () => ['testcycles'],
    listWithParams: (params) => ['testcycles', params],
    details: (id) => ['testcycle', id],
    linkedIssues: (id) => ['linkedIssues', id],
  },

  dashboard: {
    stats: () => ['dashboard', 'stats'],
    defectsOverview: (projectIds, isDashboard) => ['defectsOverview', projectIds, isDashboard],
  },

  projectDashboard: {
    defectsLogged: (projectId, jiraProjectId) => ['defectsLogged', projectId, jiraProjectId],
  },

  issues: {
    list: (params = {}) => ['issues', params],
    details: (issueId) => ['issue', issueId],
  },
};

export default QUERY_KEYS;
